/**
 * UTC Date Utilities
 *
 * All date boundaries sent to Postgres must be in UTC. Using local-timezone
 * helpers (date-fns startOfMonth, new Date(year, month, day), setHours, etc.)
 * shifts boundaries by the user's UTC offset, causing rows from the
 * previous/next period to bleed into the wrong time frame.
 *
 * These helpers guarantee the boundaries stay aligned with the UTC timestamps
 * stored in the database, regardless of the browser's timezone.
 */

/** First millisecond of the month (UTC) containing `d`. */
export const utcStartOfMonth = (d: Date) =>
  new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1));

/** Last millisecond of the month (UTC) containing `d`. */
export const utcEndOfMonth = (d: Date) =>
  new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0, 23, 59, 59, 999));

/** First millisecond of the day (UTC) containing `d`. */
export const utcStartOfDay = (d: Date) =>
  new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));

/** Last millisecond of the day (UTC) containing `d`. */
export const utcEndOfDay = (d: Date) =>
  new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 23, 59, 59, 999));

/** First millisecond of the year (UTC) containing `d`. */
export const utcStartOfYear = (d: Date) =>
  new Date(Date.UTC(d.getUTCFullYear(), 0, 1));

/** First millisecond of the previous month (UTC) relative to `d`. */
export const utcStartOfPrevMonth = (d: Date) =>
  new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - 1, 1));

/** Last millisecond of the previous month (UTC) relative to `d`. */
export const utcEndOfPrevMonth = (d: Date) =>
  new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 0, 23, 59, 59, 999));
